import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchLocationListModule } from "./helpAndAssistantApi";

export interface LocationListState {
  locationlist: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: LocationListState = {
    locationlist: [],
  status: "idle",
};

export const GetLocationList = createAsyncThunk(
  "locationList/fetchLocation",
  async (groupId:any) => {
    const response = await fetchLocationListModule(groupId);
    return response;
  }
);

export const locationListSlice = createSlice({
  name: "locationList",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetLocationList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetLocationList.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetLocationList.fulfilled, (state, action) => {
        state.status = "idle";
        state.locationlist = action.payload;
      });
  },
});

export const {} = locationListSlice.actions;

export const selectLocationList = (state: RootState) => {
  return state.LocationList.locationlist;
};

export default locationListSlice.reducer;
